var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    {
      attrs: {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M17.8776 7.49288C17.8776 10.9458 15.0213 13.769 11.4681 13.769C7.91486 13.769 5.05859 10.9458 5.05859 7.49288C5.05859 4.03993 7.91486 1.2168 11.4681 1.2168C15.0213 1.2168 17.8776 4.03993 17.8776 7.49288Z",
          stroke: "white",
          "stroke-width": "1.5"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M1.53022 8.64015C1.54335 10.7468 3.39974 14.4867 6.31627 16.3673C8.62003 17.8527 8.69904 21.1463 8.62003 22.7489",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M21.3741 8.64015C21.3609 10.7468 19.5046 14.4867 16.588 16.3673C14.2843 17.8527 14.2053 21.1463 14.2843 22.7489",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M13.6644 8.7359C13.6644 9.18557 13.5241 9.55655 13.2435 9.84883C12.9628 10.1411 12.5791 10.3266 12.0922 10.4053C12.0636 10.4165 12.0493 10.4334 12.0493 10.4559L12.0578 11.0039C12.0578 11.032 12.0464 11.0545 12.0235 11.0714C12.0063 11.0939 11.9834 11.1051 11.9548 11.1051H11.0956C11.067 11.1051 11.0412 11.0939 11.0183 11.0714C11.0011 11.0545 10.9925 11.032 10.9925 11.0039L11.0011 10.4475C11.0011 10.425 10.9868 10.4081 10.9582 10.3969C10.4713 10.3013 10.0876 10.1046 9.80692 9.80667C9.53199 9.50877 9.39453 9.13498 9.39453 8.68531V8.49982C9.39453 8.47172 9.40312 8.44923 9.42031 8.43237C9.44322 8.40989 9.46899 8.39865 9.49763 8.39865H10.4255C10.4541 8.39865 10.477 8.40989 10.4942 8.43237C10.5171 8.44923 10.5286 8.47172 10.5286 8.49982V8.62629C10.5286 8.85113 10.6288 9.04223 10.8293 9.19962C11.0298 9.35138 11.3047 9.42726 11.6541 9.42726C11.9462 9.42726 12.1609 9.36544 12.2984 9.24178C12.4416 9.1125 12.5132 8.95511 12.5132 8.76962C12.5132 8.63472 12.4702 8.5223 12.3843 8.43237C12.2984 8.33682 12.1781 8.25531 12.0235 8.18786C11.8746 8.11479 11.6369 8.01643 11.3104 7.89277C10.9381 7.76349 10.626 7.6314 10.3739 7.4965C10.1219 7.3616 9.90715 7.17892 9.72959 6.94846C9.55777 6.71238 9.47185 6.42291 9.47185 6.08004C9.47185 5.64723 9.60359 5.29031 9.86706 5.00926C10.1363 4.7226 10.4971 4.53711 10.9496 4.4528C10.9782 4.44155 10.9925 4.42469 10.9925 4.40221L10.9753 3.78672C10.9753 3.75862 10.9839 3.73613 11.0011 3.71927C11.024 3.69679 11.0498 3.68555 11.0784 3.68555H11.9376C11.9662 3.68555 11.9891 3.69679 12.0063 3.71927C12.0292 3.73613 12.0407 3.75862 12.0407 3.78672L12.0321 4.41907C12.0321 4.44155 12.0464 4.45842 12.075 4.46966C12.5504 4.56521 12.9284 4.77037 13.2091 5.08514C13.4897 5.39429 13.6301 5.7737 13.6301 6.22337V6.34984C13.6301 6.37794 13.6186 6.40324 13.5957 6.42572C13.5785 6.44258 13.5556 6.45101 13.527 6.45101H12.5905C12.5619 6.45101 12.5361 6.44258 12.5132 6.42572C12.496 6.40324 12.4874 6.37794 12.4874 6.34984V6.28239C12.4874 6.04631 12.3929 5.84677 12.2039 5.68377C12.0149 5.51514 11.7572 5.43083 11.4307 5.43083C11.1729 5.43083 10.9725 5.48704 10.8293 5.59945C10.6861 5.71187 10.6145 5.86644 10.6145 6.06317C10.6145 6.2037 10.6546 6.32173 10.7348 6.41729C10.8207 6.51284 10.9467 6.59997 11.1128 6.67866C11.2789 6.75735 11.5366 6.85853 11.886 6.98219C12.2698 7.12271 12.5733 7.24918 12.7967 7.3616C13.0201 7.47401 13.2205 7.64264 13.3981 7.86747C13.5757 8.09231 13.6644 8.38178 13.6644 8.7359Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }